import React from 'react';
import { ProfileLayout } from '../components/ProfileLayout';
import { BasicInfo } from '../components/BasicInfo';

export const BasicInfoPage = () => {
  return (
    <ProfileLayout activeTab="basic-info">
      <BasicInfo />
    </ProfileLayout>
  );
};
